import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Loading } from '@/kit';

/**
 * Bajo demanda, como Promociones. El import va al ARCHIVO y no al barrel `@/domains/credit`, que
 * arrastraría las demás pantallas al mismo chunk y anularía el split.
 */
const SegmentsPage = lazy(() =>
    import('@/domains/credit/segments/SegmentsPage').then((m) => ({
        default: m.SegmentsPage,
    })),
);

// Ruta estática: gana sobre la dinámica hermana `$section` (que sigue cubriendo el resto).
export const Route = createFileRoute('/_backoffice/credit/segments')({
    component: CreditSegments,
});

function CreditSegments() {
    return (
        <Suspense fallback={<Loading fullScreen text="Cargando segmentos…" />}>
            <SegmentsPage />
        </Suspense>
    );
}
